// extracted by mini-css-extract-plugin
export var backToTopButton = "styles-module--backToTopButton--aabeb";
export var container = "styles-module--container--97d6e";
export var content = "styles-module--content--76d5b";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var linkListItem = "styles-module--linkListItem--a38aa";
export var links = "styles-module--links--7001e";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";